<template>
  <v-col cols="11" style="margin:2em">
    <h4>Proyectos activos</h4>
    <v-card style="padding: 1em">
      <v-simple-table v-if="projects.length > 0" style="background-color: #fff !important;">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Nº Presupuesto</th>
              <th class="text-left">Descripción</th>
              <th class="text-left">Empresa</th>
              <th class="text-left">Fecha</th>
              <th class="text-left">Ver Proyecto</th>
              <th class="text-left">Ver Presupuesto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="project in projects" :key="project.projectID">
              <td>
                <span v-if="project.projectID < 10"> 0000000{{ project.projectID }}/{{ project.date_add.split("-")[0]
                }}</span>
                <span v-if="project.projectID < 100 && project.projectID >= 10"> 000000{{ project.projectID }}/{{
                  project.date_add.split("-")[0] }}</span>
                <span v-if="project.projectID < 1000 && project.projectID >= 109"> 00000{{ project.projectID }}/{{
                  project.date_add.split("-")[0] }}</span>
              </td>
              <td>{{ project.name }}</td>
              <td>{{ project.fiscalName }}</td>
              <td>{{ project.date_add }}</td>
              <td>
                <router-link :to="'/budget/' + project.projectID">
                  <v-icon>mdi-eye-outline</v-icon>
                </router-link>
              </td>
              <td>
                <a :href="'https://invoicer.grupowapps.es/generator/budget/' + project.projectID + '/' + project.userID"
                  target="_blank" rel="nofollow">
                  <v-icon>mdi-text-box-multiple-outline</v-icon>
                </a>
              </td>

            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <h3 v-else style="text-align: center">No hay proyectos pendientes</h3>
    </v-card>
  </v-col>
</template>

<script>
  export default {
    name: "pendingProjects",
    props: ['projects'],
  }
</script>